import * as React from 'react'

function IconExit(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={19}
      height={23}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.662 23h-6.16c-.86 0-1.557-.702-1.557-1.568 0-.867.697-1.569 1.557-1.569h6.16c2.33 0 4.225-1.91 4.225-4.259V7.396c0-2.348-1.896-4.26-4.225-4.26h-6.16c-.86 0-1.557-.701-1.557-1.568C3.945.702 4.642 0 5.502 0h6.16C15.708 0 19 3.318 19 7.396v8.21C19 19.683 15.708 23 11.662 23z"
        fill="#fff"
      />
      <path
        d="M10.022 13.068H1.556C.696 13.068 0 12.366 0 11.5c0-.866.697-1.568 1.556-1.568h8.466c.86 0 1.556.702 1.556 1.568 0 .866-.697 1.568-1.556 1.568z"
        fill="#fff"
      />
      <path
        d="M7.892 17.61c-.438 0-.874-.186-1.18-.548a1.577 1.577 0 01.167-2.213l3.474-3.007a.454.454 0 000-.69L6.877 8.148a1.579 1.579 0 01-.168-2.212 1.55 1.55 0 012.196-.17l3.473 3.007a3.6 3.6 0 011.243 2.727c0 1.05-.453 2.041-1.243 2.726l-3.473 3.005a1.535 1.535 0 01-1.013.378z"
        fill="#fff"
      />
    </svg>
  )
}

export default IconExit
